










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class PanelToggle extends Vue {
  @Prop({ required: true })
  panelId: string;

  @Prop({ required: true })
  collapsed: boolean;

  @Prop()
  title: string;

  private linked = false;

  onClick() {
    this.$x.emit(EVENTS.TogglePanel, this.panelId);
  }

  mounted() {
    this.$x.on(EVENTS.QuantumEntanglement).subscribe((panelId: string) => {
      if (panelId === this.panelId) {
        this.linked = true;
      }
    });
  }
}
